import { getCookieValue } from 'dibs-consented-storage';
import { getGADeviceId } from 'dibs-ga-utils';
import { hasConsentForGroups, type ConsentGroup } from './consent.ts';

const GA_DEVICE_ID_COOKIE_KEY = '_ga';

/**
 * `full_visitor_id` is GA4's `user_pseudo_id`, used to join GA4/BigQuery exports with Datadog
 * RUM. It's read from the same first-party `_ga` cookie GA4 itself writes (via GTM), so it
 * follows the Performance category, same as `dibs_session`.
 */
const FULL_VISITOR_ID_CONSENT_GROUPS: readonly ConsentGroup[] = ['C0002'];

/**
 * GA4's `user_pseudo_id`: the `_ga` cookie's `<id>.<timestamp>`, after stripping the
 * `GA1.1.`/`GA1.2.` version prefix (the shape that shows up as `user_pseudo_id` in the GA4
 * BigQuery export). `null` without Performance consent, before GTM has written `_ga`, or if the
 * cookie is malformed. Always reads live: there's no "already tried" latch, so a call made before
 * GTM has written the cookie (or before consent is granted) doesn't block a later call that would
 * succeed.
 */
export function getFullVisitorId(): string | null {
    if (
        typeof document === 'undefined' ||
        !hasConsentForGroups(document.cookie, FULL_VISITOR_ID_CONSENT_GROUPS)
    ) {
        return null;
    }
    const gaDeviceCookie = getCookieValue(document.cookie, GA_DEVICE_ID_COOKIE_KEY);
    if (!gaDeviceCookie) {
        return null;
    }
    return getGADeviceId(gaDeviceCookie);
}
